import React from "react";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import { Col, Row, Tabs, Form, Card, Modal, Button, Table, Icon, Divider, DatePicker, Statistic, Empty, notification, Input, Select, Tag, Switch, Tooltip, Popconfirm, Popover } from "antd";
import styles from '../../Template/all/styles.less'
import _, { trimEnd } from 'lodash';
import Request, { LAPI_URL, MEDIA_URL } from "../../../request";
import { FormUtils as GetAllFormFields, TableComp } from "sz-react-utils";
import { RightsWrapper } from "../../../components/_utils/utils";
import moment from "moment";
import { HiInformationCircle } from "react-icons/hi";
import PDFFileView from '../../../components/DocumentViews/PDFFileView'
const { Option } = Select;
const { TabPane } = Tabs;
const invoiceCounts = [1, 2, 3, 4, 5, 6, 7, 8];

@Form.create()
class UniversityCommission extends React.Component {
    state = {
        activeTab: '0',
        total: 0,
        universities: [],
        loading: false,
        campusIds: [],
        levelOptions: [],
        showApplicantModal: false,
        applicantsList: [],
        isOnshoreOffshoreAvailable: null,
        numberOfInvoices: 0,
        // Bonus Management State
        bonusAny: 'No',
        bonusDetails: [],
        minimumStudents: '',
        maximumStudents: '',
        bonusType: 'Per Student',
        commissionType: 'flat',
        bonus: '',
        bonusIndex: null,
        incentiveEnabled: false,
        showIncentiveModal: false,
        incentiveList: [],
        fullAgreement: null,
        commmissionPage: null,
        ext: null,
        linkUrl: null,
        activeStatus: true,
        editIndex: null,
    }

    componentDidMount() {
        this.loadUniversity();
        this.loadLevels();
    }


    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    handleEditComm = (record, index) => {
        this.setState({
            showApplicantModal: true,
            editIndex: index,
            bonusDetails: record.bonusDetails || [],
            bonusAny: record.bonusAny || 'No'
        }, () => {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    studyType: record.studyType,
                    term: record.term,
                    commissionTypeFrom: record.commissionTypeFrom,
                    commissionFromUniversity: record.commissionFromUniversity,
                    bonusAny: record.bonusAny || 'No'
                });
            }, 0);
        });
    };

    setCommissionData(commissionId) {
        if (commissionId) {
            Request.getCommissionById({ id: commissionId }).then(
                ({ doc, error, message }) => {
                    if (!error && doc) {

                        let universityId = '';
                        if (doc.universityId && doc.universityId._id) {
                            universityId = doc.universityId._id;
                        } else {
                            universityId = doc.universityId;
                        }

                        this.setState({
                            id: doc._id,
                            activeTab: '2',
                            bonusAny: doc.bonusAny,
                            bonusDetails: doc.bonusDetails || [],
                            applicantsList: doc.commDetails || [],
                            incentiveList: doc.incentiveList || [],
                            incentiveEnabled: doc.incentive ? true : false,
                            isOnshoreOffshoreAvailable: doc.isOnshoreOffshoreAvailable || null,
                            numberOfInvoices: doc.noOfInvoice
                        });

                        this.props.form.setFieldsValue({
                            universityId: universityId,
                            campusIds: doc.campusIds || [],
                            courseLevelId: doc.courseLevelId || [],
                            paymentTimeline: doc.paymentTimeline,
                            invoicePerYear: doc.invoicePerYear,
                            noOfInvoice: doc.noOfInvoice,
                            typeOfCommission: doc.typeOfCommission,
                            isOnshoreOffshoreAvailable: doc.isOnshoreOffshoreAvailable,
                            incentive: doc.incentive
                        });

                        if (universityId) {
                            this.loadUniversityCampus(universityId);
                        }

                    } else {
                        notification.error({
                            message: 'Error Getting Data',
                            description: message
                        });
                    }
                }
            );
        }
    }

    deleteCommission = async data => {
        this.setState({ loading: true })
        await Request.deleteCommission(data)

        this.setState({ loading: false })

        this.table.current.reload()

        notification.success({
            message: 'Deleted Successfully',
            duration: 20,
            key: `${data._id}-close`
        })
    }

    // --- Data Loading Methods (Logic remains the same as your snippet) ---
    loadUniversity = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then(resp => {
                const formatted = (resp.arr || []).map(vv => ({ _id: vv._id, display: vv.universityInstitutionName }));
                this.setState({ universities: formatted });
            }).catch(console.error);
    }

    apiRequest = (params) => {
        return new Promise(async resolve => {
            let { activeStatus } = this.state;
            params.activeStatus = activeStatus;
            this.setState({ exportParams: params })
            let data = await Request.getCommissionUniversities({
                ...params,
                regExFilters: [
                    'universityInstitutionName'
                ]
            });
            this.setState({ total: data.total })
            resolve(data)
        })
    }

    loadLevels = async () => {
        Request.loadSimpleLevels({ sortField: 'levelName', sortOrder: 'ascend' })
            .then(resp => {
                let temp = [{ display: '---Select All---', id: 'all' }];
                const formatted = (resp.data || []).map(vv => ({ _id: vv._id, display: vv.levelName }));
                this.setState({ levelOptions: [...temp, ...formatted] });
            }).catch(console.error);
    }

    loadUniversityCampus = async (universityId) => {
        let { data } = await Request.loadUniCampus(universityId);
        let temp = [{ display: '---Select All---', _id: 'all' }];
        const formatted = (data || []).map(vv => ({ _id: vv._id, display: vv.campusName }));
        console.log({ campusIds: [...temp, ...formatted] });
        this.setState({ campusIds: [...temp, ...formatted] });
    }

    // --- Handlers ---
    handleSubmit = (e) => {
        e.preventDefault();
        let { form } = this.props;
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                values.commDetails = this.state.applicantsList;
                values.incentiveList = this.state.incentiveList;
                let x = null
                this.setState({ loading: true });
                if (this.state.id) {
                    values._id = this.state.id
                    x = await Request.updateUniversityCommission(values)
                } else {
                    x = await Request.addUniversityCommission(values)
                }
                this.setState({ loading: false });
                if (!x.error) {
                    this.setState({
                        id: '',
                        activeTab: '0',
                    })
                    notification.success({
                        message: this.state.id
                            ? `Commission Updated Successfully`
                            : 'Commission Added successfully'
                    })
                    if (!this.state.id) {
                        form.resetFields()
                    }
                    if (this.table && this.table.current)
                        this.table.current.reload()

                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        });
    }


    handleIncentiveListSubmit = () => {
        let { form } = this.props;
        let incentiveValues = form.getFieldsValue([
            'incentiveType',
            'incentiveAmount'
        ]);


        if (!incentiveValues.incentiveType) {
            notification.error({ message: 'Expect Incentive Type!' });
            return;
        }

        if (!incentiveValues.incentiveAmount) {
            notification.error({ message: 'Expect Incentive Amount!' });
            return;
        }

        let incentiveList = [...this.state.incentiveList];
        incentiveList.push({
            ...incentiveValues,
        });
        this.setState(
            {
                incentiveList,
                showIncentiveModal: false,
            },
            () => {
                this.props.form.setFieldsValue({
                    incentiveType: null,
                    incentiveAmount: null,
                });
            }
        );
    }


    // handleCommListSubmit = () => {
    //     let { form } = this.props;
    //     let applicantFromValues = form.getFieldsValue([
    //         'studyType',
    //         'term',
    //         'commissionTypeFrom',
    //         'commissionFromUniversity'
    //     ]);

    //     if (!applicantFromValues.term) {
    //         notification.error({ message: 'Expect Term Number!' });
    //         return;
    //     }

    //     if (!applicantFromValues.commissionTypeFrom) {
    //         notification.error({ message: 'Expect Commission Type!' });
    //         return;
    //     }

    //     if (!applicantFromValues.commissionFromUniversity) {
    //         notification.error({ message: 'Expect Commission Amount' });
    //         return;
    //     }

    //     applicantFromValues.commissionFromUniversity =
    //         parseFloat(applicantFromValues.commissionFromUniversity);

    //     let applicantsList = [...this.state.applicantsList];

    //     applicantsList.push({
    //         ...applicantFromValues,
    //         bonusAny: this.state.bonusAny,
    //         bonusDetails: this.state.bonusDetails
    //     });

    //     this.setState(
    //         {
    //             applicantsList,
    //             showApplicantModal: false,
    //             bonusDetails: [],
    //             bonusAny: 'No'
    //         },
    //         () => {
    //             this.props.form.setFieldsValue({
    //                 studyType: null,
    //                 term: null,
    //                 commissionTypeFrom: null,
    //                 commissionFromUniversity: null,
    //                 bonusAny: null
    //             });
    //         }
    //     );
    // };

    handleCommListSubmit = () => {
        let { form } = this.props;

        let applicantFromValues = form.getFieldsValue([
            'studyType',
            'term',
            'commissionTypeFrom',
            'commissionFromUniversity'
        ]);

        // ✅ VALIDATIONS
        if (!applicantFromValues.term) {
            notification.error({ message: 'Expect Term Number!' });
            return;
        }

        if (!applicantFromValues.commissionTypeFrom) {
            notification.error({ message: 'Expect Commission Type!' });
            return;
        }

        if (!applicantFromValues.commissionFromUniversity) {
            notification.error({ message: 'Expect Commission Amount' });
            return;
        }

        applicantFromValues.commissionFromUniversity =
            parseFloat(applicantFromValues.commissionFromUniversity);

        let applicantsList = [...this.state.applicantsList];
        const { editIndex } = this.state;

        const newRecord = {
            ...applicantFromValues,
            bonusAny: this.state.bonusAny,
            bonusDetails: this.state.bonusDetails
        };

        // ✅ MAIN CHANGE HERE
        if (editIndex !== null && editIndex !== undefined) {
            // 👉 UPDATE
            applicantsList[editIndex] = newRecord;
        } else {
            // 👉 ADD
            applicantsList.push(newRecord);
        }

        this.setState(
            {
                applicantsList,
                showApplicantModal: false,
                bonusDetails: [],
                bonusAny: 'No',
                editIndex: null // ✅ RESET AFTER SAVE
            },
            () => {
                this.props.form.setFieldsValue({
                    studyType: null,
                    term: null,
                    commissionTypeFrom: null,
                    commissionFromUniversity: null,
                    bonusAny: null
                });
            }
        );
    };

    handleRemoveComm = (index) => {

        let applicantsList = [...this.state.applicantsList];

        applicantsList.splice(index, 1);

        this.setState({
            applicantsList
        });

    };

    getUniversityDetail = async (universityId) => {
        let { doc } = await Request.getUniversity(universityId);
        this.setState({ fullAgreement: doc && doc.paymentUpload ? doc.paymentUpload : [], commmissionPage: doc && doc.paymentUploadCommissionPage ? doc.paymentUploadCommissionPage : [] })
    }


    // --- Bonus List Logic ---
    addBonusCommission = () => {
        const { minimumStudents, maximumStudents, bonusType, commissionType, bonus, bonusDetails } = this.state;
        if (!minimumStudents || !bonus) {
            return notification.warning({ message: 'Please fill required bonus fields' });
        }
        const newBonus = { minimumStudents, maximumStudents, bonusType, commissionType, bonus };
        this.setState({
            bonusDetails: [...bonusDetails, newBonus],
            minimumStudents: '', maximumStudents: '', bonus: '', bonusIndex: null
        });
    }

    updateBonusCommission = () => {
        const { bonusIndex, bonusDetails, minimumStudents, maximumStudents, bonusType, commissionType, bonus } = this.state;
        let newList = [...bonusDetails];
        newList[bonusIndex] = { minimumStudents, maximumStudents, bonusType, commissionType, bonus };
        this.setState({
            bonusDetails: newList,
            minimumStudents: '', maximumStudents: '', bonus: '', bonusIndex: null
        });
    }

    editBonus = (index, item) => {
        this.setState({
            bonusIndex: index,
            minimumStudents: item.minimumStudents,
            maximumStudents: item.maximumStudents,
            bonusType: item.bonusType,
            commissionType: item.commissionType,
            bonus: item.bonus
        });
    }

    removeBonus = (index) => {
        const filtered = this.state.bonusDetails.filter((_, i) => i !== index);
        this.setState({ bonusDetails: filtered });
    }

    viewPDF = (file) => {
        if (file && file.length > 0) {
            let linkUrl = MEDIA_URL + file[0].url;
            let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
            if (this.checkUrlExt(linkUrl)) {
                this.setState({ ext: ext, linkUrl: linkUrl });
            } else {
                notification.warning({
                    message: 'Agreement not exists!!!.'
                })
            }
        }
    }


    updateActiveStatus = async (recordId, checked) => {
        let payload = {
            _id: recordId,
            activeStatus: checked
        }
        let response = await Request.updateUniversityCommissionActiveStatus(payload);
        if (response.success) {
            notification.success({ message: response.message })
        } else {
            notification.error({ message: response.message });
        }
        this.table.current.reload();
    }

    checkUrlExt = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    closeDocument = () => {
        this.setState({ ext: null, linkUrl: null });
    }

    render() {
        const { activeTab, total, universities, bonusAny, bonusDetails, bonusIndex, loading, campusIds, levelOptions, isOnshoreOffshoreAvailable, applicantsList, incentiveEnabled, fullAgreement, commmissionPage, ext, linkUrl } = this.state;
        const { form: { getFieldDecorator, setFieldsValue } } = this.props;

        const normalizeCommission = (record) => {
            if (record.commDetails && record.commDetails.length) {
                return record.commDetails;
            }

            if (record.commissionFromUniversity) {
                return [{
                    term: 1,
                    commissionFromUniversity: record.commissionFromUniversity,
                    commissionTypeFrom: record.commissionTypeFrom
                }];
            }

            return [];
        };

        // let content = <iframe width="560" height="315" src="https://www.youtube.com/embed/wbj-DuaL748?si=XyXq03xQl-5eToHv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        let content = "Content Here";

        const mainFormSchema = {
            fields: [
                {
                    label: 'University',
                    key: 'universityId',
                    type: 'select',
                    options: universities,
                    required: true,
                    span: 12,
                    showSearch: true,
                    onChange: v => {
                        setFieldsValue({ universityId: v, campusIds: [] });
                        this.loadUniversityCampus(v);
                        this.getUniversityDetail(v)
                    }
                },
                {
                    label: 'Commission Type',
                    key: 'typeOfCommission',
                    type: 'select',
                    options: ['Base', 'Special'],
                    required: true,
                    span: 12,
                    onChange: v => {
                        setFieldsValue({ typeOfCommission: v });
                    }
                },
                {
                    label: 'Campus',
                    key: 'campusIds',
                    type: 'select',
                    mode: 'multiple',
                    options: campusIds,
                    required: campusIds && campusIds.length > 1 ? true : false,
                    span: 12,
                    onChange: v => {
                        let val = v ? v : [];
                        if (v && v.length && v.includes("all")) {
                            if (v.length === campusIds.length) {
                                val = [];
                            } else {
                                val = campusIds.slice(1).map(campusOption => campusOption._id);
                            }
                        }
                        setFieldsValue({
                            campusIds: val
                        })
                    }
                },
                {
                    label: 'Course Levels',
                    key: 'courseLevelId',
                    type: 'select',
                    mode: 'multiple',
                    options: levelOptions,
                    required: true,
                    span: 12,
                    onChange: v => {
                        let val = v ? v : [];
                        if (v && v.length && v.includes("all")) {
                            if (v.length === levelOptions.length) {
                                val = [];
                            } else {
                                val = levelOptions.slice(1).map(levelOption => levelOption._id);
                            }
                        }
                        setFieldsValue({
                            courseLevelId: val
                        })
                    }
                },
                {
                    label: 'No. of Invoices',
                    key: 'noOfInvoice',
                    type: 'select',
                    options: invoiceCounts,
                    required: true,
                    span: 6,
                    onChange: v => {
                        setFieldsValue({ noOfInvoice: v }, () => {
                            this.setState({ numberOfInvoices: v })
                        })
                    }
                },
                {
                    label: 'Invoices Per Year',
                    key: 'invoicePerYear',
                    type: 'select',
                    options: invoiceCounts,
                    required: true,
                    span: 6,
                    onChange: v => {
                        setFieldsValue({ invoicePerYear: v })
                    }
                },
                {
                    label: 'Payment Due Post Submission of Invoice (Days)',
                    key: 'paymentTimeline',
                    required: true,
                    type: 'number'
                },
                {
                    label: 'Onshore/Offshore Differentiation?',
                    key: 'isOnshoreOffshoreAvailable',
                    type: 'select',
                    required: true,
                    span: 12,
                    options: [{ _id: 'yes', display: 'Yes' }, { _id: 'no', display: 'No' }],
                    onChange: v => {
                        setFieldsValue({ isOnshoreOffshoreAvailable: v }, () => {
                            this.setState({ isOnshoreOffshoreAvailable: v, applicantsList: [] })
                        })
                    }
                },
                {
                    label: 'Incentive Available?',
                    key: 'incentive',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({ incentive: v }, () => {
                            this.setState({ incentiveEnabled: v })
                        })
                    }
                }
            ]
        };

        const modalSchema = {
            fields: [
                {
                    label: 'Study Location',
                    key: 'studyType',
                    type: 'select',
                    options: ['Offshore', 'Onshore'],
                    hidden: isOnshoreOffshoreAvailable !== "yes",
                    required: isOnshoreOffshoreAvailable === "yes",
                    onChange: v => {
                        setFieldsValue({ studyType: v })
                    }
                },
                {
                    label: 'Term / Intake Number',
                    key: 'term',
                    type: 'select',
                    options: Array.from({ length: this.state.numberOfInvoices }, (_, i) => ({ _id: i + 1, display: `Term ${i + 1}` })),
                    required: true,
                    onChange: v => {
                        setFieldsValue({ term: v })
                    }
                },
                {
                    label: 'Commission Structure',
                    key: 'commissionTypeFrom',
                    type: 'select',
                    options: ['Flat', 'Percentage'],
                    required: true,
                    onChange: v => {
                        setFieldsValue({ commissionTypeFrom: v })
                    }
                },
                {
                    label: 'Value (Amount or %)',
                    key: 'commissionFromUniversity',
                    type: 'number',
                    required: true,
                    onChange: v => {
                        setFieldsValue({ commissionFromUniversity: v })
                    }
                },
                {
                    label: 'Add Bonus?', key: 'bonusAny', type: 'select', options: [{ _id: 'Yes', display: 'Yes' }, { _id: 'No', display: 'No' }], onChange: v => {
                        setFieldsValue({ bonusAny: v }, () => {
                            this.setState({ bonusAny: v })
                        })
                    }
                }
            ]
        };

        const incentiveSchema = {
            fields: [
                {
                    label: 'Incentive Structure',
                    key: 'incentiveType',
                    type: 'select',
                    options: ['Flat', 'Percentage'],
                    required: true,
                    onChange: v => {
                        setFieldsValue({ incentiveType: v })
                    }
                },
                {
                    label: 'Value (Amount or %)',
                    key: 'incentiveAmount',
                    type: 'number',
                    required: true,
                    onChange: v => {
                        setFieldsValue({ incentiveAmount: v })
                    }
                },
            ]
        }

        // const mainColumns = [
        //     {
        //         title: 'University Name',
        //         key: 'universityInstitutionName',
        //         width: 250,
        //         dataIndex: 'universityInstitutionName',
        //         searchTextName: "University Name",
        //     },
        //     {
        //         title: 'Commission',
        //         key: 'commissionFromUniversity',
        //         render: (text, record) => {
        //             if (!record.commDetails || !record.commDetails.length) return '-';

        //             return record.commDetails.map((item, index) => (
        //                 <div key={index}>
        //                     Term {item.term}: {item.commissionFromUniversity} {item.commissionTypeFrom === 'Percentage' ? '%' : '(Flat)'}
        //                 </div>
        //             ));
        //         }
        //     },
        //     {
        //         title: 'Country',
        //         key: 'universityCountryName',
        //         dataIndex: 'universityId.universityCountryName',
        //         searchTextName: 'Country Name'
        //     },
        //     {
        //         title: 'Total No Of Invoices / Invoice Per Year',
        //         key: 'noOfInvoice',
        //         render: (text, record) => (
        //             <div>{record.noOfInvoice}/{record.invoicePerYear}</div>
        //         )
        //     },
        //     {
        //         title: 'Payment Due (Days)',
        //         key: 'paymentTimeline',
        //         dataIndex: 'paymentTimeline'
        //     },
        //     {
        //         title: 'Commission Type',
        //         key: 'commissionTypeFrom',
        //         filters: [
        //             { text: 'Flat', value: 'Flat' },
        //             { text: 'Percentage', value: 'Percentage' }
        //         ],
        //         render: (text, record) => {
        //             if (!record.commDetails || !record.commDetails.length) return '-';
        //             return record.commDetails[0].commissionTypeFrom;
        //         }
        //     },
        //     {
        //         title: 'Status',
        //         key: 'status',
        //         dataIndex: 'status',
        //         filters: [
        //             { text: 'Pending', value: 'Pending' },
        //             { text: 'Active', value: 'Active' }
        //         ]
        //     },
        //     {
        //         title: 'Active Status',
        //         key: 'activeStatus',
        //         dataIndex: 'activeStatus',
        //         render: (text, record) => {
        //             return (
        //                 <Switch
        //                     checked={record.activeStatus}
        //                     onChange={(checked) => this.updateActiveStatus(record._id, checked)}
        //                 />
        //             );
        //         }
        //     },
        //     {
        //         title: 'Updated By',
        //         key: 'lastUpdatedByName',
        //         render: (text, record) => {
        //             const user = record.updatedByUser || record.createdByUser;
        //             return (
        //                 <div>
        //                     <div>{user ? user.name : ''}</div>
        //                     <small>
        //                         {user ? moment(user.time).format('lll') : ''}
        //                     </small>
        //                 </div>
        //             );
        //         }
        //     },
        //     {
        //         title: 'Action',
        //         key: 'operation',
        //         render: (text, record) => (
        //             <>
        //                 <RightsWrapper myRight={'financeUniversityCommission.edit'}>
        //                     <Tooltip title="Edit Commission">
        //                         <Button
        //                             className={styles.btn}
        //                             shape="circle"
        //                             onClick={() => this.setCommissionData(record._id)}
        //                             icon="edit"
        //                         />
        //                     </Tooltip>
        //                 </RightsWrapper>

        //                 <RightsWrapper myRight={'financeUniversityCommission.delete'}>
        //                     <Tooltip title="Delete Commission">
        //                         <Popconfirm
        //                             title="Are you sure delete this Commission?"
        //                             onConfirm={() => this.deleteCommission({ _id: record._id })}
        //                             okText="Yes"
        //                             cancelText="No"
        //                         >
        //                             <Button
        //                                 className={styles.btn}
        //                                 shape="circle"
        //                                 icon="delete"
        //                             />
        //                         </Popconfirm>
        //                     </Tooltip>
        //                 </RightsWrapper>
        //             </>
        //         )
        //     }
        // ];
        const mainColumns = [
            {
                title: 'University Name',
                key: 'universityInstitutionName',
                width: 250,
                dataIndex: 'universityInstitutionName',
                searchTextName: "University Name",
            },

            {
                title: 'Commission',
                key: 'commissionFromUniversity',
                render: (text, record) => {
                    const commissions = normalizeCommission(record);

                    if (!commissions.length) return '-';

                    return commissions.map((item, index) => (
                        <div key={index}>
                            {commissions.length > 1 ? `Term ${item.term}: ` : ''}
                            {item.commissionFromUniversity}{' '}
                            {item.commissionTypeFrom === 'Percentage' ? '%' : '(Flat)'}
                        </div>
                    ));
                }
            },

            {
                title: 'Country',
                key: 'universityCountryName',
                dataIndex: 'universityId.universityCountryName',
                searchTextName: 'Country Name'
            },

            {
                title: 'Total No Of Invoices / Invoice Per Year',
                key: 'noOfInvoice',
                render: (text, record) => (
                    <div>{record.noOfInvoice}/{record.invoicePerYear}</div>
                )
            },

            {
                title: 'Payment Due (Days)',
                key: 'paymentTimeline',
                dataIndex: 'paymentTimeline'
            },
            // {
            //     title: 'Commission Type',
            //     key: 'commissionTypeFrom',
            //     filters: [
            //         { text: 'Flat', value: 'Flat' },
            //         { text: 'Percentage', value: 'Percentage' }
            //     ],
            //     render: (text, record) => {

            //         if (record.commDetails && record.commDetails.length) {
            //             return record.commDetails[0].commissionTypeFrom;
            //         }

            //         if (record.commissionTypeFrom) {
            //             return record.commissionTypeFrom;
            //         }

            //         return '-';
            //     }
            // },
            {
                title: 'Status',
                key: 'status',
                dataIndex: 'status',
                filters: [
                    { text: 'Pending', value: 'Pending' },
                    { text: 'Active', value: 'Active' }
                ]
            },

            {
                title: 'Active Status',
                key: 'activeStatus',
                dataIndex: 'activeStatus',
                render: (text, record) => {
                    return (
                        <Switch
                            checked={record.activeStatus}
                            onChange={(checked) =>
                                this.updateActiveStatus(record._id, checked)
                            }
                        />
                    );
                }
            },

            {
                title: 'Updated By',
                key: 'updatedBy',

                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div style={{ padding: 8 }}>
                        <DatePicker
                            value={selectedKeys[0]}
                            onChange={(date) => setSelectedKeys(date ? [date] : [])}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                        <Button type="primary" onClick={confirm} size="small">
                            Filter
                        </Button>
                        <Button onClick={clearFilters} size="small">
                            Reset
                        </Button>
                    </div>
                ),

                render: (text, record) => {
                    const user = record.updatedByUser || record.createdByUser;

                    return (
                        <div>
                            <div>{user ? user.name : ''}</div>
                            <small>
                                {user ? moment(user.time).format('lll') : ''}
                            </small>
                        </div>
                    );
                }
            },
            {
                title: 'Approved By',
                key: 'approvedBy',

                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div style={{ padding: 8 }}>
                        <DatePicker
                            value={selectedKeys[0]}
                            onChange={(date) => setSelectedKeys(date ? [date] : [])}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                        <Button type="primary" onClick={confirm} size="small">
                            Filter
                        </Button>
                        <Button onClick={clearFilters} size="small">
                            Reset
                        </Button>
                    </div>
                ),

                render: (text, record) => {
                    const user = record && record.status === "Active" && record.approvedBy;

                    return (
                        <div>
                            <div>{user ? user.name : ''}</div>
                            <small>
                                {user ? moment(user.time).format('lll') : ''}
                            </small>
                        </div>
                    );
                }
            },

            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <>
                        <RightsWrapper myRight={'financeUniversityCommission.edit'}>
                            <Tooltip title="Edit Commission">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    onClick={() =>
                                        this.setCommissionData(record._id)
                                    }
                                    icon="edit"
                                />
                            </Tooltip>
                        </RightsWrapper>

                        <RightsWrapper myRight={'financeUniversityCommission.delete'}>
                            <Tooltip title="Delete Commission">
                                <Popconfirm
                                    title="Are you sure delete this Commission?"
                                    onConfirm={() =>
                                        this.deleteCommission({ _id: record._id })
                                    }
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button
                                        className={styles.btn}
                                        shape="circle"
                                        icon="delete"
                                    />
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                    </>
                )
            }
        ];
        const columns = [
            { title: 'Term', dataIndex: 'term', render: t => `Term ${t}` },
            { title: 'Type', dataIndex: 'studyType', render: s => s || 'N/A' },
            { title: 'Value', render: (r) => `${r.commissionFromUniversity} ${r.commissionTypeFrom === 'Percentage' ? '%' : '(Flat)'}` },
            { title: 'Bonus', render: (r) => r.bonusAny === 'Yes' ? <Tag color="gold">{r.bonusDetails.length} Rules</Tag> : 'No' },
            {
                title: 'Action',
                key: 'action',
                render: (text, record, index) => (
                    <span>
                        <Button
                            type="link"
                            icon="edit"
                            onClick={() => this.handleEditComm(record, index)}
                        />
                        <Popconfirm
                            title="Are you sure remove this commission?"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => this.handleRemoveComm(index)}
                        >
                            <Button
                                type="link"
                                icon="delete"
                                className="text-danger"
                            />
                        </Popconfirm>
                    </span>

                )
            }
        ];
        const incentiveColumns = [
            {
                title: 'Incentive Type',
                dataIndex: 'incentiveType',
                render: t => t || 'N/A'
            },
            {
                title: 'Value',
                dataIndex: 'incentiveAmount',
                render: (v, r) =>
                    `${v} ${r.incentiveType === 'Percentage' ? '%' : '(Flat)'}`
            },
            {
                title: 'Action',
                render: (_, record, index) => (
                    <Button
                        type="link"
                        icon="delete"
                        className="text-danger"
                        onClick={() => {
                            const list = [...this.state.incentiveList];
                            list.splice(index, 1);
                            this.setState({ incentiveList: list });
                        }}
                    />
                )
            }
        ];

        let types = ['Base', 'Special'];

        return (
            <PageHeaderWrapper title="University Commission Management">
                {
                    ext != null && linkUrl != null ?
                        <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
                        : null
                }
                <Card bordered={true} style={{ marginBottom: 10 }}>
                    <Row gutter={16}>
                        <Col span={8}>
                            <Button type="primary" onClick={() => this.setState({ activeStatus: !this.state.activeStatus }, () => this.table.current.reload())}>{this.state.activeStatus ? 'Inactive Commission' : "Active Commission"}</Button>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={false} className="custom-card">

                    <Tabs
                        activeKey={activeTab}
                        onChange={(v) => this.setState({ activeTab: v })}
                        type="line"
                    >
                        {types.map((type, index) => (
                            <TabPane
                                tab={<span><Icon type="unordered-list" />{type} Commissions</span>}
                                key={String(index)}
                            >
                                <Row gutter={16} style={{ marginBottom: 20 }}>
                                    <Col span={6}>
                                        <Card style={{ background: '#f0f2f5' }}>
                                            <Statistic title={`Total ${type} Commissions`} value={total} prefix={<Icon type="file-done" />} />
                                        </Card>
                                    </Col>
                                </Row>
                                {activeTab === String(index) && (
                                    <TableComp
                                        ref={this.table}
                                        columns={mainColumns}
                                        apiRequest={(params) =>
                                            this.apiRequest({ ...params, typeOfCommission: type })
                                        }
                                        extraProps={{ scroll: { x: 1300 } }}
                                        locale={{ emptyText: <Empty description="No commissions configured yet." /> }}
                                        pagination={{
                                            showSizeChanger: true,
                                            defaultPageSize: 50,
                                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                                        }}
                                    />
                                )}
                            </TabPane>


                        ))}

                        <TabPane tab={<span><Icon type="plus-circle" />Add New Commission</span>} key="2">
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '20px',
                                padding: '10px 0',
                                borderBottom: '1px solid #f0f0f0'
                            }}>
                                {/* Left Side: Info Popover */}
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Popover content={content} title="Help Information">
                                        <HiInformationCircle style={{
                                            cursor: 'pointer',
                                            fontSize: '22px',
                                            color: '#8878ff',
                                            transition: 'transform 0.2s'
                                        }} />
                                    </Popover>
                                </div>

                                {/* Right Side: Action Buttons */}
                                <div style={{ display: 'flex', gap: '12px' }}>
                                    {fullAgreement && fullAgreement.length > 0 && (
                                        <Button
                                            type="primary"
                                            ghost
                                            icon="file-pdf"
                                            onClick={() => this.viewPDF(fullAgreement)}
                                        >
                                            Full Agreement
                                        </Button>
                                    )}

                                    {commmissionPage && commmissionPage.length > 0 && (
                                        <Button
                                            icon=" eye"
                                            onClick={() => this.viewPDF(commmissionPage)}
                                        >
                                            Commission Page
                                        </Button>
                                    )}
                                </div>
                            </div>


                            <Form onSubmit={this.handleSubmit} layout="vertical">
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Divider orientation="left">1. University Details</Divider>
                                        <GetAllFormFields
                                            inputSchema={mainFormSchema}
                                            getFieldDecorator={getFieldDecorator}
                                        />
                                    </Col>
                                </Row>

                                {isOnshoreOffshoreAvailable && (
                                    <div style={{ marginTop: 30 }}>
                                        <Divider orientation="left">2. Commission Breakdowns</Divider>
                                        <Card title="Detailed Terms" extra={<Button type="primary" ghost icon="plus" onClick={() => this.setState({ showApplicantModal: true })}>Add Breakdown</Button>}>
                                            <Table
                                                bordered
                                                size="small"
                                                dataSource={applicantsList}
                                                columns={columns}
                                                pagination={false}
                                            />
                                        </Card>
                                    </div>
                                )}

                                {incentiveEnabled && (
                                    <div style={{ marginTop: 30 }}>
                                        <Divider orientation="left">3. Incentive Breakdowns</Divider>
                                        <Card title="Detailed Terms" extra={<Button type="primary" ghost icon="plus" onClick={() => this.setState({ showIncentiveModal: true })}>Add Breakdown</Button>}>
                                            <Table
                                                bordered
                                                size="small"
                                                dataSource={this.state.incentiveList}
                                                columns={incentiveColumns}
                                                pagination={false}
                                            />
                                        </Card>
                                    </div>
                                )}

                                <div style={{ textAlign: 'right', marginTop: 40 }}>
                                    <Button size="large" style={{ marginRight: 10 }}>Reset</Button>
                                    <Button type="primary" size="large" htmlType="submit" loading={loading} icon="save">
                                        Save Commission
                                    </Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>

                </Card>

                {/* Incentive BreakDown Modal */}

                <Modal
                    destroyOnClose
                    title={<span><Icon type="percentage" /> Incentive Setup</span>}
                    visible={this.state.showIncentiveModal}
                    width={900}
                    onCancel={() => this.setState({ showIncentiveModal: false })}
                    footer={[
                        <Button key="back" onClick={() => this.setState({ showIncentiveModal: false })}>Cancel</Button>,
                        <Button key="submit" type="primary" icon="plus-square" onClick={this.handleIncentiveListSubmit}>Add to Main List</Button>
                    ]}
                >
                    <Form layout="horizontal">
                        <GetAllFormFields inputSchema={incentiveSchema} getFieldDecorator={getFieldDecorator} />
                    </Form>
                </Modal>

                {/* Breakdown Modal */}
                <Modal
                    destroyOnClose
                    title={
                        <span>
                            <Icon type="percentage" /> Commission & Bonus Setup
                        </span>
                    }
                    visible={this.state.showApplicantModal}
                    width={900}
                    onCancel={() =>
                        this.setState({
                            showApplicantModal: false,
                            bonusAny: null,
                            bonusDetails: [],
                            editIndex: null // ✅ reset edit mode
                        })
                    }
                    footer={[
                        <Button
                            key="back"
                            onClick={() =>
                                this.setState({
                                    showApplicantModal: false,
                                    editIndex: null
                                })
                            }
                        >
                            Cancel
                        </Button>,

                        <Button
                            key="submit"
                            type="primary"
                            icon={this.state.editIndex !== null ? "edit" : "plus-square"}
                            onClick={this.handleCommListSubmit}
                        >
                            {this.state.editIndex !== null
                                ? "Update"
                                : "Add to Main List"}
                        </Button>
                    ]}
                >
                    <Form layout="horizontal">
                        <GetAllFormFields
                            inputSchema={modalSchema}
                            getFieldDecorator={this.props.form.getFieldDecorator}
                        />

                        {/* ✅ BONUS SECTION */}
                        {this.state.bonusAny === 'Yes' && (
                            <Card
                                title={
                                    <span>
                                        <Icon type="gift" /> Bonus Logic
                                    </span>
                                }
                                style={{ marginTop: 20, background: '#fafafa' }}
                            >
                                <Row gutter={12} align="bottom" type="flex">
                                    <Col span={4}>
                                        <label>Min Qty</label>
                                        <Input
                                            type="number"
                                            placeholder="Min"
                                            value={this.state.minimumStudents}
                                            onChange={e =>
                                                this.setState({
                                                    minimumStudents: e.target.value
                                                })
                                            }
                                        />
                                    </Col>

                                    <Col span={4}>
                                        <label>Max Qty</label>
                                        <Input
                                            type="number"
                                            placeholder="Max"
                                            value={this.state.maximumStudents}
                                            onChange={e =>
                                                this.setState({
                                                    maximumStudents: e.target.value
                                                })
                                            }
                                        />
                                    </Col>

                                    <Col span={5}>
                                        <label>Bonus Calculation</label>
                                        <Select
                                            style={{ width: '100%' }}
                                            value={this.state.bonusType}
                                            onChange={v =>
                                                this.setState({ bonusType: v })
                                            }
                                        >
                                            <Option value="Per Student">Per Student</Option>
                                            <Option value="Total Student">Total Student</Option>
                                        </Select>
                                    </Col>

                                    <Col span={5}>
                                        <label>Value Type</label>
                                        <Select
                                            style={{ width: '100%' }}
                                            value={this.state.commissionType}
                                            onChange={v =>
                                                this.setState({ commissionType: v })
                                            }
                                        >
                                            <Option value="flat">Flat Amount</Option>
                                            <Option value="percantage">Percentage</Option>
                                        </Select>
                                    </Col>

                                    <Col span={4}>
                                        <label>Value</label>
                                        <Input
                                            type="number"
                                            placeholder="Value"
                                            value={this.state.bonus}
                                            onChange={e =>
                                                this.setState({ bonus: e.target.value })
                                            }
                                        />
                                    </Col>

                                    <Col span={2}>
                                        <Button
                                            type="primary"
                                            ghost
                                            icon={
                                                this.state.bonusIndex !== null
                                                    ? "edit"
                                                    : "plus"
                                            }
                                            onClick={
                                                this.state.bonusIndex !== null
                                                    ? this.updateBonusCommission
                                                    : this.addBonusCommission
                                            }
                                        >
                                            {this.state.bonusIndex !== null
                                                ? "Update"
                                                : "Add"}
                                        </Button>
                                    </Col>
                                </Row>

                                <Table
                                    size="small"
                                    style={{ marginTop: 15 }}
                                    dataSource={this.state.bonusDetails}
                                    pagination={false}
                                    rowKey={(r, i) => i}
                                    columns={[
                                        {
                                            title: 'Range',
                                            render: r =>
                                                `${r.minimumStudents} - ${r.maximumStudents || '∞'}`
                                        },
                                        { title: 'Calc', dataIndex: 'bonusType' },
                                        { title: 'Type', dataIndex: 'commissionType' },
                                        { title: 'Bonus', dataIndex: 'bonus' },
                                        {
                                            title: 'Action',
                                            render: (_, r, i) => (
                                                <span>
                                                    <a onClick={() => this.editBonus(i, r)}>
                                                        Edit
                                                    </a>
                                                    <Divider type="vertical" />
                                                    <a
                                                        className="text-danger"
                                                        onClick={() =>
                                                            this.removeBonus(i)
                                                        }
                                                    >
                                                        Delete
                                                    </a>
                                                </span>
                                            )
                                        }
                                    ]}
                                />
                            </Card>
                        )}
                    </Form>
                </Modal>
            </PageHeaderWrapper>
        );
    }
}

export default UniversityCommission;